import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import "./InvoiceDashboard.css";

export default function Dashboard() {

  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState("");

  const [selectedYear, setSelectedYear] = useState("");

  /* ================= FETCH WHEN FILTER CHANGES ================= */

  useEffect(() => {

    
      fetchDashboard();
    

  }, [selectedMonth, selectedYear]);

  /* ================= FETCH DASHBOARD ================= */

  const fetchDashboard = async () => {

    try {

      const res = await API.get(
        "/dashboard",
        {
          params: {
            month: selectedMonth,
            year: selectedYear
          }
        }
      );

      setEmployees(res.data);

    } catch (err) {

      console.log(err);

    }

  };

  /* ================= MONTHS ================= */

  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  /* ================= YEARS ================= */

  const years = [];

  for (let y = 2025; y <= 2026; y++) {

    years.push(y);

  }

  return (

    <div className="dashboard-container">

      <h1 className="title">
        Invoice Dashboard
      </h1>

      
      {/* ================= FILTERS ================= */}

      <div
        style={{
          display: "flex",
          gap: "15px",
          marginBottom: "20px"
        }}
      >

        {/* ================= MONTH DROPDOWN ================= */}

        <select
          value={selectedMonth}
          onChange={(e) =>
            setSelectedMonth(
              e.target.value
            )
          }
          className="filter-dropdown"
        >

          <option value="">
            Select Month
          </option>

          {months.map((month) => (

            <option
              key={month}
              value={month}
            >
              {month}
            </option>

          ))}

        </select>

        {/* ================= YEAR DROPDOWN ================= */}

        <select
          value={selectedYear}
          onChange={(e) =>
            setSelectedYear(
              e.target.value
            )
          }
          className="filter-dropdown"
        >

          <option value="">
            Select Year
          </option>

          {years.map((year) => (

            <option
              key={year}
              value={year}
            >
              {year}
            </option>

          ))}

        </select>

      </div>

      {/* ================= TABLE ================= */}

      <div className="table-container">

        <table className="employee-table">

          <thead>

            <tr>

              <th>
                Employee Name
              </th>

              <th>
                Attendance
              </th>

              <th>
                Expense
              </th>

              <th>
                Reimbursement
              </th>

              <th>
                Total Amount
              </th>

              <th>
                View
              </th>

            </tr>

          </thead>

          <tbody>

            {employees.length > 0 ? (

              employees.map((emp) => (

                <tr key={emp._id}>

                  <td>
                    {emp.name}
                  </td>

                  <td>
                    ₹ {emp.attendance}
                  </td>

                  <td>
                    ₹ {emp.expense}
                  </td>

                  <td>
                    ₹ {emp.reimbursement}
                  </td>

                  <td>

                    ₹ {

                      (
                        emp.attendance +
                        emp.reimbursement
                      ) - emp.expense

                    }

                  </td>

                  <td>

                  <button
className="view-btn"
onClick={() =>
navigate(
`/employee/${emp._id}?month=${selectedMonth}&year=${selectedYear}`
)
}
>
View
</button>
                  </td>

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan="6"
                  style={{
                    textAlign: "center",
                    padding: "20px"
                  }}
                >
                  No Data Found
                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

    </div>

  );

}